<script setup lang="ts">
import { useAuthStore } from '~/store/authStore'

const user = await useAuthStore().getUser()
const localePath = useLocalePath()

const { data: list } = useApi('/rankings', {
  query: {
    page: 1,
    per_page: 10,
    mine: true,
  },
  key: 'manage-my-rankings',
})
</script>

<template>
  <UiCard :title="$t('Rankings')">
    <template #actions>
      <UiButton
        :to="localePath('/manage/rankings')"
        :text="$t('View all')"
        icon="tabler-arrow-up"
        size="sm"
      />
    </template>
    <UiList v-if="user?.can_manage_rankings && (list?.data?.length ?? 0) > 0">
      <RankingsRankingCard
        v-for="ranking in list?.data"
        :key="ranking.id"
        :to="localePath(`/manage/rankings/${ranking.id}`)"
        :ranking="ranking"
      >
        <template #actions>
          <UiButton
            :text="$t('Manage')"
            size="sm"
          />
        </template>
      </RankingsRankingCard>
    </UiList>
    <UiCardContent v-else-if="user?.can_manage_rankings">
      <UiAlert
        :title="$t('No rankings yet.')"
      />
      <UiButton
        :to="localePath('/manage/rankings/create')"
        :text="$t('Create a ranking')"
        size="sm"
      />
    </UiCardContent>
    <UiCardContent v-else-if="!user?.can_manage_rankings">
      <UiAlert
        :title="$t('Rankings is a pro feature.')"
      >
        <template #action>
          <UiButton
            :to="localePath('/profile/settings')"
            :text="$t('Upgrade')"
          />
        </template>
      </UiAlert>
    </UiCardContent>
  </UiCard>
</template>
